import { render } from "./BottomNavigationMobile.vue?vue&type=template&id=04b9084c&scoped=true"
import script from "./BottomNavigationMobile.vue?vue&type=script&lang=js"
export * from "./BottomNavigationMobile.vue?vue&type=script&lang=js"

import "./BottomNavigationMobile.vue?vue&type=style&index=0&id=04b9084c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b9084c"]])

export default __exports__